import { defineStore } from 'pinia'
import { useAppInsights } from 'vue3-application-insights'
import { trackCaughtError, trackEntryView } from '@/config/insight/tracking.insight'

export const useInsightStore = defineStore('insightStore', () => {
  const insights = useAppInsights()
  const connectionString = import.meta.env.VITE_KEY_INSIGHTS

  function trackEvent(name: string, properties: any): void {
    insights.trackEvent({ name }, { properties })
  }
  function trackMetric(name: string, average: number, properties: any): void {
    insights.trackMetric({ name, average }, { properties })
  }
  function trackException(exception: Error, severityLevel?: number, moreInfo?: any): void {
    insights.trackException(
      {
        exception,
        severityLevel
      },
      {
        moreInfo
      }
    )
  }

  function trackTrace(message: string, entryProperties: any): void {
    insights.trackTrace(
      {
        message
      },
      { properties: entryProperties }
    )
  }

  function trackError(err: unknown, extra?: Record<string, any>): void {
    if (connectionString) {
      trackCaughtError(connectionString, err, extra)
    }
  }

  function trackPageView(pageName: string, extra?: Record<string, any>): void {
    if (connectionString) {
      trackEntryView(connectionString, pageName, extra)
    }
  }

  return {
    trackEvent,
    trackMetric,
    trackException,
    trackTrace,
    trackError,
    trackPageView
  }
})
